import { format } from 'date-fns'
import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { jobsActions } from 'src/ducks/actions'
import { getStatistiscs } from 'src/ducks/selectors'
import headers from './headers'

const Week = () => {
  const [tableLoading, setTableLoading] = useState(true)
  const dispatch = useDispatch()
  const statisticsList = useSelector(getStatistiscs())
  const formatDate = 'MM/dd/yyyy'

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchServices = useCallback(() => {
    setTableLoading(true)
    const fistDayOfWeek = moment().startOf('week').add(1, 'days').toDate()
    const lastDayOfWeek = moment().endOf('week').add(2, 'days').toDate()

    dispatch(jobsActions.fetchJobsCounts({
      searchParams: {
        startDate: format(fistDayOfWeek, formatDate),
        endDate: format(lastDayOfWeek, formatDate)
      }
    }, (_succ: boolean) => {
      setTableLoading(false)
    }))
  }, [])

  useEffect(() => {
    fetchServices()
  }, [dispatch, fetchServices])

  return (
    <Table
      headers={headers}
      hasPagination={false}
      loading={tableLoading}
    >
      {statisticsList ?? []}
    </Table>
  )
}

export default Week
